<template>
  <div>
    <!-- 横幅图片 -->
    <el-carousel ref="carousel" class="divimage" :height="screenHeight" :interval="5000" :loop=true  @change="changePicture"  @mouseenter.native="delHandleMouseEnter" arrow="hover">
      <el-carousel-item :key="index" v-for="(url, index) in bannerList">
        <div class="divimage banner-image banner-animate"  :style="{'background-image': 'url(\'' + url + '\')' }">
          <!-- <el-image  
            :src="require(`@/assets/images/${url}.jpg`)" 
            class="banner-animate">
          </el-image> -->
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 横幅上的悬浮动画组件 -->
    <banner-title :id="idIndex"></banner-title>
    <!-- 4个产品页签 -->
       <div class="filler-piece3"></div>
      <div class="text-center">
          <h2 class="font-36"><strong>我们的产品</strong></h2>
          <h3 class="title-desc">我们始终专注钢铁行业智能制造，帮助您尽可能减少人力成本，提高企业高效智能化水平</h3>
      </div>
    <about-desc /> 
    <!-- 解决方案组件 -->
       <div class="filler-piece3"></div>
    <div class="text-center">
        <h2 class="font-36"><strong>行业解决方案</strong></h2>
        <h3 class="title-desc">不仅仅提供产品，还提供配套完善解决方案</h3>
    </div>
    <about-tab2 /> 
    <!-- 江苏精益智控 -->
    <div class="filler-piece3"></div>
    <!-- <div class="text-center">
      <span class="main-color main-font">江苏精益</span>
      <p class="text-center main-text font-18 font-color">
        诚信经营，是您值得信赖的伙伴
      </p>
    </div> -->
    <!-- <div class="text-center">
        <h2 class="font-36"><strong>江苏精益</strong></h2>
        <h3 class="title-desc">诚信经营，是您值得信赖的伙伴</h3>
    </div>
    <el-row :gutter="20" type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <p
          class="line-height-2 gray-color text-left font-14"
          :class="{ 'animated fadeInUp': fontShow1 }"
          ref="ref1">
          &nbsp; &nbsp;&nbsp;
          &nbsp;江苏精益智控科技有限公司位于江苏省无锡市滨湖区的旭天科技园，注册资本1000万元，取得“双软”资质并获得高新技术企业认证。
          公司长期致力于钢铁工业的自动化、信息化及智能化的技术研发及应用。
          公司团队主要由钢铁行业的专家及冶金院校的优秀人才组成，并与黑龙江建龙、四川达钢、中钢特材、邯郸中普、兴澄特钢、涟钢等大型钢铁企业建立了长期稳定的合作关系。
          通过智能制造体系的推进，为客户带来巨大经济效益，有效实现降本增效，赢得了客户的信赖。
          <el-button type="text" @click="showAbout">查看详情</el-button>
        </p>
      </el-col>
    </el-row>
    <el-row :gutter="20" type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <div class="divimage">
          <el-image
            :src="require('../assets/images/home3.jpg')"
            class="image-transition-scale2">
          </el-image>
        </div>
      </el-col>
    </el-row> -->
    <!-- 了解我们 -->
    <!-- <div class="filler-piece3"></div>
    <div class="filler-piece3"></div>
     <div class="text-center">
        <h2 class="font-36"><strong>了解我们</strong></h2>
        <h3 class="title-desc"> 选择我们，为您提供最优质的服务</h3>
    </div>
     <div class="filler-piece3"></div>
    <about-list />  -->
     <!-- 我们的产品 -->
     <!-- 垫片 -->
    <!-- <div class="filler-piece3"></div>
    <div class="filler-piece3"></div> -->
    <!-- <div class="text-center">
    <span class="main-color main-font">我们的产品</span>
      <p class="text-center main-text font-18 font-color">
        匠心智造，精益求精，不断超越
      </p>
    </div> -->
      <!-- 产品组件共用 -->
   <!-- <div class="text-center">
        <h2 class="font-36"><strong>我们的产品</strong></h2>
        <h3 class="title-desc"> 匠心智造，精益求精，不断超越</h3>
    </div>
   <home-product></home-product> -->
   <!-- <product-list :span="16"></product-list>   -->
    <!-- <el-row :gutter="20" type="flex" justify="center" v-if="isPc">
       <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <el-carousel height="300px" :interval="2000">
          <el-carousel-item :key="index" v-for="(url, index) in productList">
            <el-image
              :src="require(`@/assets/images/${url}.jpg`)">
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <div>
             <el-row :gutter="20"   justify="center">
               <el-col :span="24" >
                    <el-image :src="require('@/assets/images/product.png')"  v-for="index in 3" :key="index" style="height:45px;">
                   </el-image>
              </el-col>
             </el-row>
            <el-row :gutter="20" type="flex" justify="center">
                    <el-col :span="24">
                      <p class="line-height-2 gray-color text-left font-14"
                        :class="{ 'animated bounceIn': fontShow2 }"
                        ref="ref2">
                           1.三电系统集成的综合解决方案：电器传动系统、基础自动化系统、L2过程控制系统  
                          <br />
                            2.冶金领域智能化装备: 视觉定位、缺陷检测、尺寸测量、机器手臂代人取物等，为客户提供智能机器代人的解决方案 
                          <br />
                            3.冶金领域智能制造综合解决方案提供商：运营自动化、装备智能化、生产执行过程管控智能化、仓储物流智能化  
                        <el-button type="text" @click="showProduct">查看详情</el-button>
                      </p>  
                 </el-col>
            </el-row>
          </div>   
      </el-col>
    </el-row>
    <el-row :gutter="20" v-else>
      <el-col :span="24">
        <p
          class="line-height-2 gray-color text-left font-14"
          :class="{ 'animated bounceIn': fontShow2 }"
          ref="ref2">
           1.三电系统集成的综合解决方案：电器传动系统、基础自动化系统、L2过程控制系统 
          <br />
           2.冶金领域智能化装备: 视觉定位、缺陷检测、尺寸测量、机器手臂代人取物等，为客户提供智能机器代人的解决方案
          <br />
            3.冶金领域智能制造综合解决方案提供商：运营自动化、装备智能化、生产执行过程管控智能化、仓储物流智能化
          <el-button type="text" @click="showProduct">查看详情</el-button>
        </p>
      </el-col>
      <el-col :span="24">
        <el-carousel height="200px" :interval="2000">
          <el-carousel-item :key="index" v-for="(url, index) in productList">
            <el-image
              :src="require(`@/assets/images/${url}.jpg`)"
              class="image-transition" >
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row> -->
    <!-- 核心技术 -->
    <!-- <div class="filler-piece3"></div>
    <div class="filler-piece3"></div>
    <div class="text-center">
        <h2 class="font-36"><strong>核心技术</strong></h2>
        <h3 class="title-desc">  致力于冶金领域工业自动化、信息化、智能化</h3>
    </div>
    <div class="filler-piece3"></div>
    <div v-if="isPc">
     <el-row :gutter="20" type="flex" justify="center" v-for="index in 2" :key="index" :class="index==1? '': 'mt5'">
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4" v-for="(item, i) in techIconList.slice((index-1)*4,index*4)" :key="i" >
          <div class="div-icon-image">
            <el-image
              :src="require(`@/assets/images/${item}.png`)"
              class="icon-image image-transition-scale2">
            </el-image>
            <div>
              <p v-if="index==1 && i === 0">热轧钢卷机器人贴标</p>
              <p v-else-if="index==1 && i === 1">三电系统总施工</p>
              <p v-else-if="index==1 && i === 2">设备状态在线监测</p>
              <p v-else-if="index==1 && i === 3">冷轧钢卷机器人贴标</p>
              <p v-else-if="index==2 && i === 0">机器人手臂自动抓取</p>
              <p v-else-if="index==2 && i === 1">炼钢炼铁领域生产管理</p>
              <p v-else-if="index==2 && i === 2">AI视觉定位</p>
              <p v-else>AI检测分析</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <el-row :gutter="20" type="flex" justify="center"  v-for="index in 4" :key="index" class="mt10">
        <el-col :span="11" v-for="(item, i) in techIconList.slice((index-1)*2,index*2)" :key="i" >
          <div class="div-icon-phone-image">
            <el-image
              :src="require(`@/assets/images/${item}.png`)"
              class="icon-phone-image image-transition-scale2">
            </el-image>
            <div>
              <p v-if="index==1 && i === 0">热轧钢卷机器人贴标</p>
              <p v-else-if="index==1 && i === 1">三电系统总施工</p>
              <p v-else-if="index==2 && i === 0">设备状态在线监测</p>
              <p v-else-if="index==2 && i === 1">冷轧钢卷机器人贴标</p>
              <p v-else-if="index==3 && i === 0">机器人手臂自动抓取</p>
              <p v-else-if="index==3 && i === 1">炼钢炼铁领域生产管理</p>
              <p v-else-if="index==4 && i === 0">AI视觉定位</p>
              <p v-else>AI检测分析</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div> -->
    <!-- 应用场景 -->
    <!-- <div class="filler-piece3"></div>
    <div class="filler-piece3"></div>
    <div class="text-center">
        <h2 class="font-36"><strong>应用场景</strong></h2>
        <h3 class="title-desc">   我们的产品已经广泛应用于冶金行业</h3>
    </div>
    <div>
    <el-row :gutter="20" type="flex" justify="center" v-for="i in 2" :key="i"  :class="i==1? '': 'mt20'">
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="4"
          :xl="4"
          v-for="(item, index) in sceneList.slice((i-1)*4,i*4)"
          :key="index">
          <div class="divimage">
            <el-image
              :src="require(`@/assets/images/${item}.jpeg`)"
              class="sceneimage image-transition-scale2"></el-image>
          </div>
        </el-col>
    </el-row>
    </div> -->
    <!-- 企业定位 -->
    <!-- <div class="filler-piece3"></div>
    <div class="filler-piece3"></div> -->
    <!-- <div class="text-center">
      <span class="main-color main-font">企业定位</span>
    </div>
    <p class="text-center main-text font-18 font-color">
      致力于工业生产的自动化、信息化、智能化
    </p> -->
      <!-- <div class="text-center">
        <h2 class="font-36"><strong>企业定位</strong></h2>
        <h3 class="title-desc"> 您身边的工厂超级自动化专家</h3>
    </div> -->
    <div :style="bg1" class="bgheight">
      <el-row type="flex" justify="center" align="middle">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="16">
          <div style="padding:20px">
           <h2 class="font-36"><strong>企业使命</strong></h2>
            <p
              class="line-height-2 font-20 text-left letter-sapce-2" style="color:#555;"
              ref="ref3"
              :class="{ 'animated fadeInUp': fontShow3 }">
               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;长期专注于钢铁行业的数智化转型升级，综合利用大数据技术、机器视觉及AI人工智能等技术为钢铁生产企业的高质量发展提供整体解决方案，助力钢铁企业从数字化迈向智能化。
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 企业定位 -->
    <div>
      <el-row align="middle">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <div class="divleft flex-box-center">
            <p
              class="font-30 white-color"
              :class="{ 'animated bounceIn': fontShow4 }" >
              您身边的工厂超级自动化专家
            </p>
            <p
              class="font-20 white-color"
              :class="{ 'animated bounceIn': fontShow4 }">
              The factory super automation expert around you
            </p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16" align="left">
          <div class="divright flex-box-row">
            <div
              class="dviindex4titem"
              :class="{'animated bounceIn': fontShow4 }"
              ref="ref4">
              <el-image
                :src="require('../assets/images/ico1.png')"
                class="icon-transition"
              ></el-image>
              <p class="font-16">企业精神</p>
              <p class="font-14">精益求精，匠心智造</p>
            </div>
            <div
              class="dviindex4titem"
              :class="{ 'animated bounceIn': fontShow4 }" >
              <el-image
                :src="require('../assets/images/ico4.png')"
                class="icon-transition"></el-image>
              <p class="font-16">企业愿景</p>
              <p class="font-14">更智能、更安全、更美好</p>
            </div>
            <div
              class="dviindex4titem"
              :class="{ 'animated bounceIn': fontShow4 }">
              <el-image
                :src="require('../assets/images/ico3.png')"
                class="icon-transition"
              ></el-image>
              <p class="font-16">企业追求</p>
              <span class="font-14">发挥数据价值 </span>
            </div>
            <div
              class="dviindex4titem"
              :class="{ 'animated bounceIn': fontShow4 }">
              <el-image
                :src="require('../assets/images/ico2.png')"
                class="icon-transition"
              ></el-image>
              <p class="font-16">企业理念</p>
              <p class="font-14">客户至上 专业 高效</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 新闻动态 -->
    <div class="filler-piece3"></div>
    <div class="filler-piece3"></div>
    <!-- <div class="text-center">
      <span class="main-color main-font">新闻动态</span>
      <p class="text-center main-text font-18 font-color">
        这里有我们最新的资讯信息
      </p>
    </div> -->
    <div class="text-center">
        <h2 class="font-36"><strong>新闻资讯</strong></h2>
        <h3 class="title-desc">发布最新动态，传递精益之声</h3>
    </div>
     <!-- 新闻组件 -->
    <home-news></home-news> 
    <div class="filler-piece3"></div>
     <!-- 合作伙伴 -->
     <div class="text-center">
        <h2 class="font-36"><strong>合作伙伴</strong></h2>
        <h3 class="title-desc">加入我们，携手共进，合作共赢</h3>
    </div>
    <partner></partner>
    <!-- 你与梦想只有一步之遥 -->
    <div class="filler-piece3"></div>
        <div class="filler-piece3"></div>
    <!-- <h2 class="font-28"><strong>找对方向,您与梦想只有一步之遥！</strong></h2> -->
    <!-- <p class="text-center main-text font-18">机会总是留给有准备的人</p> -->
    <!-- <el-row type="flex" justify="center" align="middle" v-if="isPc">
      <el-col :span="24">
        <div class="dark-blue-color div-height">
          <p class="font-22 white-color p-shadow">
            江苏精益——欢迎各界朋友莅临参观、指导！
          </p>
          <el-divider></el-divider>
        </div>
      </el-col>
    </el-row> -->
  </div>
</template>
<script>
import AboutList from '@/components/AboutList.vue';
//import ProductList  from '@/components/ProductList.vue';
import HomeNews from '@/components/HomeNews.vue';
import HomeProduct from '@/components/HomeProduct.vue';
import BannerTitle from '@/components/BannerTitle.vue';
import AboutDesc from '@/components/AboutDesc.vue';
import AboutTab2 from '@/components/AboutTab2.vue' ;
import Partner from '@/components/Partner.vue';
export default {
  name: "HomeView",
  components: {
    AboutList,
    //ProductList,
    HomeNews,
    HomeProduct,
    BannerTitle,
    AboutDesc,
    AboutTab2,
    Partner
  },
  data() {
    return {
      isPc: true, //用来区分是否为手机端
      fadeInElements: [],
      fontShow1: true,
      fontShow2: true,
      fontShow3: true,
      fontShow4: true,
      fontShow5: true,
      fontShow6: true,
      bg1: {
        backgroundImage: "url(" + require("../assets/images/gsdwbg.jpg") + ")",  //废弃
      },
      screenHeight: "200px",
      sceneList: ["scene1", "scene2", "scene3", "scene4","scene5", "scene6", "scene7", "scene8"],//应用场景
      productList: ["product1", "product2", "product3", "product4"], //公司产品
      bannerList: [require("../assets/images/banner_12.jpg") , require("../assets/images/banner_15.jpg"), require("../assets/images/banner_13.jpg")], //横幅(背景图引入)
      bannerPcList: [ require("../assets/images/banner_12.jpg") , require("../assets/images/banner_15.jpg"), require("../assets/images/banner_13.jpg")], //废弃
      bannerPhoneList: [ //废弃
        "banner_phone_04",
        "banner_phone_05",
        "banner_phone_06",
      ], //手机端横幅
      techIconList: ["icon_tech1", "icon_tech2", "icon_tech3", "icon_tech4","icon_tech5", "icon_tech6", "icon_tech72", "icon_tech8"],//技术图标
      idIndex:1,//banner悬浮提示动画(通过回调函数获取的图片Id索引，传递给banner-title组件)
    };
  },
  methods: {
    showAbout() {
      this.$router.push({ name: "about" });
    },
    showProduct() {
      this.$router.push({ name: "product" });
    },
    handleScroll() {
      // 实现当滚动到指定位置，触发动画
      let _this = this;
      let refArray = [
        { ref: "ref1", show: "fontShow1" },
        { ref: "ref2", show: "fontShow2" },
        { ref: "ref3", show: "fontShow3" },
        { ref: "ref4", show: "fontShow4" },
      ];
      refArray.forEach((r) => {
        _this.gdjz(r.ref, 200, () => {
          _this[r.show] = false;
          setTimeout(() => {
            _this[r.show] = true;
          }, 100);
        });
      });
    },
    gdjz(div, offset, callback) {
      //offset暂时未使用
      let dom = this.$refs[div];
      if (dom) {
        let b =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop; //  获取窗口滚动条高度
        // c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
        if (div == "ref1") {
          if (b >= 450 && b <= 500) {
            callback && callback();
          }
        } else if (div == "ref2") {
          if (b >= 2050 && b <= 2100) {
            callback && callback();
          }
        } else if (div == "ref3") {
          if (b >= 1700 && b <= 1760) {
            callback && callback();
          }
        } else if (div == "ref4") {
          if (b >= 2100 && b <= 2300) {
            callback && callback();
          }
        } else if (div == "ref5") {
          if (b >= 1340 && b <= 1350) {
            callback && callback();
          }
        }
      }
    },
    comoutedHeight() {
      if (document.documentElement.clientWidth >= 960 && document.documentElement.clientWidth<=1650) {
        this.screenHeight = "740px";
        // this.bannerList = this.bannerPcList;（废弃）
      } 
      else if (
        document.documentElement.clientWidth >1650 
      ) {
        this.screenHeight = "940px";
        // this.bannerList = this.bannerPcList;（废弃）
      } else if (
        document.documentElement.clientWidth >= 800 &&
        document.documentElement.clientWidth < 960
      ) {
        this.screenHeight = "320px";
        // this.bannerList = this.bannerPcList;（废弃）
      } else {
        this.screenHeight = "200px";
        // this.bannerList = this.bannerPhoneList;（废弃）
      }
    },
    btnNewsDetail(id){ //新闻详情页
     this.$router.push({
        path:'/NewsDetail',
        query:{ id: id}
      })
    },
    changePicture(newVal){ //轮播图切换时回调方法
       this.idIndex=newVal+1;
    },
    delHandleMouseEnter() { //清除轮播图鼠标hover自动暂停事件
          this.$refs.carousel.handleMouseEnter = () => { };
      }
  },
  created() {
     this.isPc = this.$store.state.isPc;
   //this.isPc=this.$util.isPc();
    this.comoutedHeight();
  },
  mounted() {
    this.$refs.carousel.handleMouseEnter = () => { }; //去除轮播图鼠标hover自动暂停
    // 先获取全部需要过渡效果的元素
    this.fadeInElements = Array.from(
      document.getElementsByClassName("animated")
    );
    // 监听鼠标滚动事件
    document.addEventListener("scroll", this.handleScroll);
    //监听屏幕高度变化
    window.onresize = () => {
      return (() => {
        this.comoutedHeight();
      })();
    };
  },
};
</script>
<style scoped>
@import "../../style/main.css";
@import "../../style/homeanimate.css";

 .title-desc{
   font-size:18px;
   color:#555;
  line-height:1.8em;
  display:block;
  font-weight:500;
  font-family:inherit;
  margin-top:-10px;
 }
.bottom {
    /* margin-top: 10px; */
    line-height: 15px; 
  }

.newsButton{
    float: right;
}
.divimage {
  height: 100%;
  width: 100%;
  overflow: hidden;
}


.div-height {
  height: 100px;
  overflow: hidden;
}
.bgheight {
  height: 300px;
}
.carouselheight {
  height: 390px;
}

.divleft {
  text-shadow: 1px 1px 1px #000;
  /* background-color: #2f89fc;   */
  background-color: #38567e;
  height: 260px;
}
.divright {
  background-color: #38567e;
  background-size: cover;
  height: 260px;
}

.padding-product {
  padding: 0 20px 0 0;
}
.padding-10 {
  padding: 10px;
}
.dviindex4titem {
  text-align: center;
  width: 185px;
  height: 185px;
  background-color: rgba(255, 255, 255, 0.6);
  margin: 5px 2%;
  padding: 10px 2%;
  border-radius: 10px;
  /* clear:both; */
}

.div-icon-image {
  height: 100px;
  width: 100%;
  overflow: hidden;
   border: 1px solid #f4f4f6;     
  border-radius: 5px;
  padding: 20px 2%;
   box-shadow: 0 6px 20px 0 #d7e8ff; 
}
.icon-image {
  width: 60px;
  width: 60px;
}

.div-icon-phone-image {
  height: 80px;
  width: 100%;
  overflow: hidden;
   border: 1px solid #f4f4f6;  
  border-radius: 5px;
  padding: 20px 2%;
  box-shadow: 0 6px 20px 0 #d7e8ff; 
}
.icon-phone-image {
  width: 40px;
  width: 40px;
}

.div-icon-image:hover .icon-image {
  transform: scale(1.3, 1.3);
  color: #000;
}
.div-icon-image:hover {
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
}

.div-about-icon-image {
  height: 220px;
  width: 100%;
  overflow: hidden;
  /* border: 1px solid #f4f4f6; */
  border-radius: 5px;  
  padding: 20px 0 0 0;
  box-shadow: 0 6px 20px 0 #d7e8ff;
  background-color: #fff;
 
}
.about-icon-image {
  width: 60px;
  width: 60px;
  /* border-radius: 50%; */
}

.card-news-height{
   height: 462px;
}


.banner-image{
    background-repeat: no-repeat;
    background-size:cover;
   }
</style>